<template>
  <div class="content-430 page-index">
    <!-- 步骤条 -->
    <div class="step-block">
      <section class="step">
        <div class="left" :class="step == -1 ? 'active' : ''">
          <div class="icon-left"></div>
          <div class="icon-middle">1.选择学校</div>
          <div class="icon-right"></div>
        </div>
        <div class="left" :class="step == 1 ? 'active' : ''">
          <div class="icon-left"></div>
          <div class="icon-middle">2.确定退款日期</div>
          <div class="icon-right"></div>
        </div>
        <div></div>
      </section>
    </div>
    <!-- 第一步的搜索框 -->
    <div v-show="step==-1" class="step-one">
      <Form ref="searchForm" :label-width="500">
        <FormItem label="学校">
          <div class="sch-form-item">
            <span v-if="portOrg == 2">{{ userInfo.orgName }}</span>
            <RemoteSelect
              v-if="portOrg != 2"
              v-model="searchConds.schoolId"
              style="width:300px"
              placeholder="请选择学校"
              :remote-method="remoteGetSchoolList"
              :loading="loadingSchool"
              @clear="remoteGetSchoolList('')"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item, index) in schoolIdList"
                :key="item.orgId + index"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </div>
        </FormItem>
        <FormItem label="学期">
          <Select
            v-model="searchConds.termId"
            filterable
            :disabled="
              (!searchConds.schoolId && portOrg != 2) ||
                searchConds.schoolId == -1
            "
            :placeholder="
              (!searchConds.schoolId && portOrg != 2) ||
                searchConds.schoolId == -1
                ? '请选择学校'
                : '请选择'
            "
            style="width:300px"
          >
            <Option
              v-for="(item, index) in termIdList"
              :key="index"
              :value="item.termId"
            >{{ item.vearName }}{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <Button
            type="primary"
            @click="handleToNext"
          >确定，下一步</Button>
        </FormItem>
      </Form>
    </div>
    <div v-if="step==1" class="step-two">
      <BatchRefundEditStepTwo :search-conds="searchConds" @toLastStep="toLastStep"></BatchRefundEditStepTwo>
    </div>
  </div>
</template>
<script>
import operationAdmin from '@/request/operationAdmin/index.js';
import courseCenter from '@/request/courseCenter/index.js';
import RemoteSelect from '@c/RemoteSelect';
import BatchRefundEditStepTwo from './components/BatchRefundEditStepTwo';
export default {
  components: {
    RemoteSelect,
    BatchRefundEditStepTwo
  },
  data() {
    return {
      step: -1,
      portOrg: Number(localStorage.getItem('portOrg')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      searchConds: {
        schoolId: '',
        termId: ''
      },
      schoolIdList: [],
      loadingSchool: false,
      termIdList: []
    };
  },
  watch: {
    'searchConds.schoolId': {
      handler(newval, oldVal) {
        this.searchConds.termId = -1;
        if (newval && newval != -1 && newval != oldVal) {
          this.getyearTermsListFun(newval);
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 学校端
      if (this.portOrg == 2) {
        this.searchConds.schoolId = this.userInfo.orgId;
        // this.getEduAreaName(this.userInfo.orgId);
      } else {
        this.getgoodSchoolListFun();
      }
    },
    remoteGetSchoolList(queryTrue) {
      this.getgoodSchoolListFun(queryTrue);
    },
    loadAllList(val) {
      if (!val) {
        this.remoteGetSchoolList('');
      }
    },
    // 搜索框 学校列表 运营端,教育局
    async getgoodSchoolListFun(searchStr) {
      const params = {
        pageNum: 1,
        pageSize: 20,
        searchStr
      };
      const res = await operationAdmin.getListSchoolsNewByOfficeAreaCode(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        this.schoolIdList = [
          { orgId: -1, name: '全部学校' },
          ...res.message.list.map(item => {
            return { orgId: item.orgId, name: item.name };
          })
        ];
      }
    },
    // 搜索框 学期列表
    async getyearTermsListFun(newval) {
      const params = {
        schoolId: newval
      };
      const res = await courseCenter.getyearTermsList(params);
      if (res.status === 200) {
        this.termIdList = [
          { termId: -1, name: '全部学期' },
          ...res.message.map(item => {
            return {
              termId: item.termId,
              name: `${item.yearName}${item.termName}`
            };
          })
        ];
      }
    },
    handleToNext() {
      if (this.searchConds.schoolId === -1 || this.searchConds.schoolId === '') {
        this.$Message.error('请先选择学校');
        return false;
      }
      if (this.searchConds.termId === -1 || this.searchConds.termId === '') {
        this.$Message.error('请先选择学期');
        return false;
      }
      this.step = 1;
    },
    toLastStep() {
      this.step = -1;
    }
  }
};
</script>
<style lang="scss" scoped>
.step-block {
  padding: 16px 15% 0;
  position: relative;
}
.step {
  display: flex;
  .left {
    width: 50%;
    height: 40px;
    display: flex;

    // background: #488ffa;
    .icon-left {
      width: 0;
      height: 0;
      border-top: 20px solid rgb(247, 248, 250);
      border-left: 10px solid transparent;
      border-bottom: 20px solid rgb(247, 248, 250);
    }

    .icon-middle {
      width: 100%;
      background: rgb(247, 248, 250);
      color: black;
      font-weight: 600;
      text-align: center;
      line-height: 40px;
      // font-size: 20px;
    }

    .icon-right {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-left: 10px solid rgb(247, 248, 250);
      border-bottom: 20px solid transparent;
    }
  }

  .left.active {
    .icon-left {
      width: 0;
      height: 0;
      border-top: 20px solid #488ffa;
      border-left: 10px solid transparent;
      border-bottom: 20px solid #488ffa;
    }

    .icon-middle {
      width: 100%;
      background: #488ffa;
      color: #fff;
      font-weight: 600;
      // font-size: 20px;
      text-align: center;
      line-height: 40px;
    }

    .icon-right {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-left: 10px solid #488ffa;
      border-bottom: 20px solid transparent;
    }
  }
}
.step-one{
  padding: 120px 0;
}
.item-box-430 {
  padding: 30px;
}
.step-two {
  padding-top: 50px;
  max-height: calc(100vh - 270px);
  overflow-y: auto;
}
</style>
